import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class FileSize extends PureComponent {
  render() {
    const { file } = this.props;

    if (file.type === 'link' || file.type_group === 'link') {
      return null;
    }

    return (
      <span className="file-size">
        {file.readable_size}
      </span>
    );
  }
}

FileSize.propTypes = {
  file: PropTypes.object.isRequired,
};

export default FileSize;
